module.exports = __webpack_public_path__ + "static/pnall-771b6f81fc9077974737e16a959efd59.png";